import type { FC } from 'react';
import React from 'react';

import type { TCheckbox } from './models';

export const WrappedCheckbox: FC<TCheckbox> = ({ Checkbox, ...rest }) => (
    <Checkbox color="green" {...rest} />
);
